import "../programsdash/ProgramsDash.css";
import MessageThread from "../../components/messageThread/MessageThread";
import MessageList from "../../components/messageList/MessageList";
import Menu from "../../components/menu/Menu";
import "./Messages.css";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const Messages = (props) => {
  const [userId, setUserId] = useState("");
  const [threadPatientName, setThreadPatientName] = useState("");
  const [messageOpen, setMessageOpen] = useState(false);
  const [isLoadedThread, setIsLoadedThread] = useState(false);
  const [isLoadedMessages, setIsLoadedMessages] = useState(false);
  const [programId, setProgramId] = useState(0);

  const closeChatBox = () => {
    setMessageOpen(false);
  };

  const isSuperAdmin =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).super_admin === 1
        ? true
        : false
      : false;

  const isCompanyAdmin =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).company_admin === 1
        ? true
        : false
      : false;

  let { id } = useParams();
  useEffect(() => {
    if (id) {
      setUserId(id);
      setMessageOpen(true);
      setThreadPatientName(
        localStorage.getItem("patientName")
          ? localStorage.getItem("patientName")
          : ""
      );
    }
  }, [id]);
  const handleUserMessages = (
    currentUser,
    fromUser,
    patientName,
    programId
  ) => {
    let therapist = JSON.parse(localStorage.getItem("userData"));
    setMessageOpen(true);
    setThreadPatientName(patientName);
    setProgramId(programId);
    if (currentUser !== therapist.id) {
      setUserId(currentUser);
    } else if (fromUser !== therapist.id) {
      setUserId(fromUser);
    }
  };

  const isThreadLoaded = (val) => {
    setIsLoadedThread(val);
  };

  const isMessagesLoaded = (val) => {
    setIsLoadedMessages(val);
  };





  const [innerWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Add event listener for resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="message_container">
      <Menu title={"Messages"} />
      <div className="dash_info_hold">
        
      {innerWidth >= 700 ? (
          <>
            {!isLoadedMessages || !isLoadedThread ? (
              <div className="loader_message_container">
                <div className="p_load mess_p_load"></div>
              </div>
            ) : null}
          </>
        ) : (
          <>
            {!isLoadedThread && (
              <div className="loader_message_container">
                <div className="p_load mess_p_load"></div>
              </div>
            )}
          </>
        )}

         
      {
        innerWidth < 700 ? 
        <>
        {
          !messageOpen ?
        <div
          className="message_thread"
          style={{
            display:
              isLoadedThread ? "inline-block" : "none",
          }}
        >
          <MessageThread
            handleUserMessages={handleUserMessages}
            actSidebar={props.actSidebar}
            checkLoggedIn={props.checkLoggedIn}
            isThreadLoaded={isThreadLoaded}
          />
        </div>
:
        <div
          className="message_list"
          // style={{
          //   display:
          //     isLoadedMessages && isLoadedThread ? "inline-block" : "none",
          // }}
        >
          <MessageList
            userMessageList={userId}
            threadPatientName={threadPatientName}
            messageOpen={messageOpen}
            programId={programId}
            isMessagesLoaded={isMessagesLoaded}
            isSuperAdmin={isSuperAdmin}
            isCompanyAdmin={isCompanyAdmin}
            closeChatBox={closeChatBox}
          />
        </div>
}
        </>
        :
        <>
        <div
          className="message_thread"
          style={{
            display:
              isLoadedMessages && isLoadedThread ? "inline-block" : "none",
          }}
        >
          <MessageThread
            handleUserMessages={handleUserMessages}
            actSidebar={props.actSidebar}
            checkLoggedIn={props.checkLoggedIn}
            isThreadLoaded={isThreadLoaded}
          />
        </div>
        <div
          className="message_list"
          style={{
            display:
              isLoadedMessages && isLoadedThread ? "inline-block" : "none",
          }}
        >
          <MessageList
            userMessageList={userId}
            threadPatientName={threadPatientName}
            messageOpen={messageOpen}
            programId={programId}
            isMessagesLoaded={isMessagesLoaded}
            isSuperAdmin={isSuperAdmin}
            isCompanyAdmin={isCompanyAdmin}
            closeChatBox={closeChatBox}
          />
        </div>
        </>
      }

      </div>
    </div>
  );
};

export default Messages;
